import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "./index.css";
import "./styles/index.scss";
import "./styles/animations.css";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import configureStore from "./redux/store/configureStore";
import { BrowserRouter } from "react-router-dom";

const { store, persistor } = configureStore();

// Remove preloader when app loads
setTimeout(() => {
	const preloader = document.querySelector('.preloader');
	if (preloader) {
		preloader.classList.add('hidden');
	}
}, 500);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ToastContainer position='top-right' autoClose={2000} />
			<GoogleReCaptchaProvider reCaptchaKey='6LcU1z0hAAAAAHJMWGUZudi6kUuTw5ZeF0qOosQh'>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</GoogleReCaptchaProvider>
		</PersistGate>
	</Provider>
);
